import React from 'react';
import HeroSection from './sections/HeroSection';
import AuthoritySection from './sections/AuthoritySection';
import QualificationSection from './sections/QualificationSection';
import ProgramBreakdown from './sections/ProgramBreakdown';
import MathSection from './sections/MathSection';
import InvestmentSection from './sections/InvestmentSection';
import MentorshipSection from './sections/MentorshipSection';
import SocialProofSection from './sections/SocialProofSection';
import FAQSection from './sections/FAQSection';
import FinalCTASection from './sections/FinalCTASection';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <HeroSection />
      <AuthoritySection />
      <QualificationSection />
      <ProgramBreakdown />
      <MathSection />
      <InvestmentSection />
      <MentorshipSection />
      <SocialProofSection />
      <FAQSection />
      <FinalCTASection />
    </div>
  );
};

export default LandingPage;